import axios from 'axios';
import { ACCESS_TYPE, VENDING_URL } from '../atoms/const';

const total = {
  hourly: (day: number) => {
    const token = sessionStorage.getItem('token');
    const url = `${VENDING_URL}hourly-totalsales?numberOfDays=${day}`;
    const config = {
      headers: { Authorization: `${ACCESS_TYPE} ${token}` },
    };
    return axios.get(url, config);
  },
  daily: (day: number) => {
    const token = sessionStorage.getItem('token');
    const url = `${VENDING_URL}daily-totalsales?numberOfDays=${day}`;
    const config = {
      headers: { Authorization: `${ACCESS_TYPE} ${token}` },
    };
    return axios.get(url, config);
  },
  weekly: (month: number) => {
    const token = sessionStorage.getItem('token');
    const url = `${VENDING_URL}weekly-totalsales?numberOfMonths=${month}`;
    const config = {
      headers: { Authorization: `${ACCESS_TYPE} ${token}` },
    };
    return axios.get(url, config);
  },
  monthly: (month: number) => {
    const token = sessionStorage.getItem('token');
    const url = `${VENDING_URL}monthly-totalsales?numberOfMonths=${month}`;
    const config = {
      headers: { Authorization: `${ACCESS_TYPE} ${token}` },
    };
    return axios.get(url, config);
  },
};

const route = {
  hourly: (routeId: number, day: number) => {
    const token = sessionStorage.getItem('token');
    const url = `${VENDING_URL}route-hourly-totalsales?routeId=${routeId}&numberOfDays=${day}`;
    const config = {
      headers: { Authorization: `${ACCESS_TYPE} ${token}` },
    };
    return axios.get(url, config);
  },
  daily: (routeId: number, day: number) => {
    const token = sessionStorage.getItem('token');
    const url = `${VENDING_URL}route-daily-totalsales?routeId=${routeId}&numberOfDays=${day}`;
    const config = {
      headers: { Authorization: `${ACCESS_TYPE} ${token}` },
    };
    return axios.get(url, config);
  },
  weekly: (routeId: number, month: number) => {
    const token = sessionStorage.getItem('token');
    const url = `${VENDING_URL}route-weekly-totalsales?routeId=${routeId}&numberOfMonths=${month}`;
    const config = {
      headers: { Authorization: `${ACCESS_TYPE} ${token}` },
    };
    return axios.get(url, config);
  },
  monthly: (routeId: number, month: number) => {
    const token = sessionStorage.getItem('token');
    const url = `${VENDING_URL}route-monthly-totalsales?routeId=${routeId}&numberOfMonths=${month}`;
    const config = {
      headers: { Authorization: `${ACCESS_TYPE} ${token}` },
    };
    return axios.get(url, config);
  },
};

const client = {
  hourly: (clientId: number, day: number) => {
    const token = sessionStorage.getItem('token');
    const url = `${VENDING_URL}client-hourly-totalsales?clientId=${clientId}&numberOfDays=${day}`;
    const config = {
      headers: { Authorization: `${ACCESS_TYPE} ${token}` },
    };
    return axios.get(url, config);
  },
  daily: (clientId: number, day: number) => {
    const token = sessionStorage.getItem('token');
    const url = `${VENDING_URL}client-daily-totalsales?clientId=${clientId}&numberOfDays=${day}`;
    const config = {
      headers: { Authorization: `${ACCESS_TYPE} ${token}` },
    };
    return axios.get(url, config);
  },
  weekly: (clientId: number, month: number) => {
    const token = sessionStorage.getItem('token');
    const url = `${VENDING_URL}client-weekly-totalsales?clientId=${clientId}&numberOfMonths=${month}`;
    const config = {
      headers: { Authorization: `${ACCESS_TYPE} ${token}` },
    };
    return axios.get(url, config);
  },
  monthly: (clientId: number, month: number) => {
    const token = sessionStorage.getItem('token');
    const url = `${VENDING_URL}client-monthly-totalsales?clientId=${clientId}&numberOfMonths=${month}`;
    const config = {
      headers: { Authorization: `${ACCESS_TYPE} ${token}` },
    };
    return axios.get(url, config);
  },
};

const vm = {
  hourly: (vmId: number, day: number) => {
    const token = sessionStorage.getItem('token');
    const url = `${VENDING_URL}vm-hourly-totalsales?vmId=${vmId}&numberOfDays=${day}`;
    const config = {
      headers: { Authorization: `${ACCESS_TYPE} ${token}` },
    };
    return axios.get(url, config);
  },
  daily: (vmId: number, day: number) => {
    const token = sessionStorage.getItem('token');
    const url = `${VENDING_URL}vm-daily-totalsales?vmId=${vmId}&numberOfDays=${day}`;
    const config = {
      headers: { Authorization: `${ACCESS_TYPE} ${token}` },
    };
    return axios.get(url, config);
  },
  weekly: (vmId: number, month: number) => {
    const token = sessionStorage.getItem('token');
    const url = `${VENDING_URL}vm-weekly-totalsales?vmId=${vmId}&numberOfMonths=${month}`;
    const config = {
      headers: { Authorization: `${ACCESS_TYPE} ${token}` },
    };
    return axios.get(url, config);
  },
  monthly: (vmId: number, month: number) => {
    const token = sessionStorage.getItem('token');
    const url = `${VENDING_URL}vm-monthly-totalsales?vmId=${vmId}&numberOfMonths=${month}`;
    const config = {
      headers: { Authorization: `${ACCESS_TYPE} ${token}` },
    };
    return axios.get(url, config);
  },
};

const analytics = {
  total,
  route,
  client,
  vm,
};

export default analytics;
